"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Category_1 = __importDefault(require("./Category"));
class Product {
    constructor({ id, name, category }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            category: this.category,
        });
        this.id = id;
        this.name = name;
        this.category = category;
    }
}
Product.fromJSON = (json) => {
    const { id, name, category } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    const _category = typeof category !== 'undefined' ? Category_1.default.fromJSON(category) : undefined;
    return new Product({
        id,
        name,
        category: _category,
    });
};
exports.default = Product;
